import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../api/client";

const ExpenseOptionsContext = createContext(null);

export function ExpenseOptionsProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  const load = useCallback(() => {
    api.get("/expense/options")
      .then(r => { setCategories(r.data.categories || []); setCurrencies(r.data.currencies || []); })
      .catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);

  const addOption = async (type, value) => {
    await api.post("/expense/options", { type, value });
    if (type === "category") setCategories(prev => prev.includes(value) ? prev : [...prev, value]);
    else setCurrencies(prev => prev.includes(value) ? prev : [...prev, value]);
  };

  return (
    <ExpenseOptionsContext.Provider value={{ categories, currencies, addOption }}>
      {children}
    </ExpenseOptionsContext.Provider>
  );
}

export const useExpenseOptions = () => useContext(ExpenseOptionsContext);
